// Source contracts are explicit. Never flatten arbitrary message bodies or private notes.
export const sources = [
  ['profile', 'Profile', 'Contact details'], ['crm', 'CRM', 'Choose an opportunity'],
  ['whatsapp', 'WhatsApp', 'Choose a conversation'], ['memory', 'AI memory', 'Saved facts · review before use'],
  ['meetings', 'Meetings', 'Choose a meeting'], ['email', 'Mail', 'Choose your mailbox and email'],
];
export const label = key => key.split('.').map(p => p.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())).join(' · ');
export const present = v => v !== null && v !== undefined && String(v).trim() !== '';
const scalar = v => ['string','number','boolean'].includes(typeof v);
const keyPart = v => String(v).replace(/[^a-zA-Z0-9_]/g, '_');
export function fieldsFor(source, result, record) {
  const fields = [];
  const add = (key, value, title, extra = {}) => {
    if (value != null && !scalar(value)) return;
    fields.push({ key, value: value == null ? '' : String(value).slice(0,4000), label: title || label(key), source, recordId: record?.id || null, fetchedAt: result.fetched_at, ...extra });
  };
  if (source === 'profile') {
    add('customer.name',result.name,'Name');
    for (const id of result.identifiers || []) if (['email','phone'].includes(id.type)) add(`customer.${id.type}`,id.value,label(id.type));
    for (const [key, field] of Object.entries(result.fields || {})) {
      if (field.present && !field.cleared) add(`customer.fields.${keyPart(key)}`,field.value,field.label || label(key));
    }
  } else if (source === 'meetings' && record) {
    for (const key of ['title','status']) add(`meetings.${key}`,record[key],label(key));
    for (const key of ['start','end']) {
      const value=record[key];
      add(`meetings.${key}`,value&&!Number.isNaN(Date.parse(value))?new Date(value).toLocaleString([], {dateStyle:'medium',timeStyle:'short'})+' '+Intl.DateTimeFormat().resolvedOptions().timeZone:'',label(key));
    }
    if (record.status === 'confirmed' && /^https:\/\/meet\.google\.com\/[a-z0-9-]+$/i.test(record.meet_url || '')) add('meetings.join_url',record.meet_url,'Google Meet link');
  } else if (source === 'memory' && record) {
    for (const item of result.items || []) {
      if (!item.id?.startsWith('memory:fact:')) continue;
      // Facts are deliberately reviewed, not silently considered confirmed or public.
      add(`ai.${keyPart(item.id.slice(12))}`,item.details?.Value,item.title,{reviewRequired:true, note:'Saved AI fact · check suitability before sharing'});
    }
  } else if (source === 'email' && result.message) {
    const m=result.message;
    for(const k of ['subject','date','from']) add(`mail.${k}`,m.headers?.[k],label(k));
    // Body/attachments may contain unrelated or private content; not offered as fields.
  } else if (record && ['crm','whatsapp'].includes(source)) {
    add(`${source}.name`,record.title,source==='crm'?'Opportunity':'Conversation');
    for(const [k,v] of Object.entries(record.details || {})) add(`${source}.${keyPart(k).toLowerCase()}`,v,k);
  }
  return fields;
}
export function resolveText(text, values) {
  const missing=[];
  const body=text.replace(/\{\{([a-zA-Z][a-zA-Z0-9_.]*)\}\}/g,(token,key)=>{
    if(!present(values[key])){missing.push(key);return token;}return String(values[key]);
  });
  return {body,missing:[...new Set(missing)]};
}

// A field from one opportunity/meeting must never silently rebind to another.
export function scopedField(field) {
  if (!field.recordId) return field;
  const record = Array.from(String(field.recordId), c => /[a-zA-Z0-9]/.test(c) ? c : '_' + c.codePointAt(0).toString(16) + '_').join('');
  const [source, ...path] = field.key.split('.');
  return {...field, key: `${source}.record_${record}.${path.join('.')}`};
}
